import { gql } from '@apollo/client'
import { SaleCreateError } from './sale_create'

export interface GqlSaleAddress {
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  postalCode: string
  countryCode: string
  suburb: string
}

export interface SaleAddressMutationData {
  billingAddress: GqlSaleAddress
  shippingAddress: GqlSaleAddress
  customerId: string
}

export interface SaleAddressMutationResponse {
  CreateSaleAddresses: {
    billingAddressId: string
    billingAddressToken: string
    shippingAddressId: string
    shippingAddressToken: string
    created: boolean
    error: SaleCreateError
  }
}

export const createSaleAddressesMutation = gql`
  mutation CreateSaleAddressesMutation($input: CreateSaleAddressesInput!) {
    createSaleAddresses(input: $input) {
      billingAddressId
      shippingAddressId
      billingAddressToken
      shippingAddressToken
      created
      error {
        code
        field
        message
      }
    }
  }
`
